import Reflux from "reflux";
export const OrderConfirmationPageActions = {
	onCheckoutSubmitSuccess: Reflux.createAction(["onCheckoutSubmitSuccess"]),
};
